import home from './src/home.vue'
import users from './src/usersManager/users.vue' //用户管理列表
import userinfo from './src/usersManager/userinfo.vue' //用户管理详情
import choseroles from './src/usersManager/choseroles.vue' //角色分配
import orgs from './src/orgsManager/orgs.vue' //用户管理详情
import products from './src/productManager/products.vue' //产品管理列表
import productinfo from './src/productManager/productinfo.vue' //产品管理详情
import roles from './src/rolesManager/roles.vue' //角色管理列表
import roleinfo from './src/rolesManager/roleinfo.vue' //角色管理详情
import menus from './src/menuManager/menus.vue' //菜单管理详情

let views = {
    home,
    users,
    userinfo,
    choseroles,
    orgs,
    products,
    productinfo,
    roles,
    roleinfo,
    menus
};

export default views;